var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.05 31.05 40 20 40C8.95 40 0 31.05 0 20C0 8.95 8.95 0 20 0C31.05 0 40 8.95 40 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9501 9.69977C28.4501 8.84977 26.5001 9.59977 26.0001 11.2498L22.7001 21.4498L19.8501 17.6498C18.7501 16.1998 16.5001 16.5498 15.9001 18.1998L12.7001 26.6998L11.4001 21.8498C11.1501 20.8498 9.75006 20.7498 9.35006 21.6998L7.40006 25.9498C7.20006 26.3498 7.50006 26.7998 7.95006 26.7998C8.15006 26.7998 8.35006 26.6998 8.50006 26.4998L9.65006 24.5498L10.8501 30.0498C11.2001 31.6998 13.4501 31.9498 14.2001 30.4498L18.2501 22.0498L21.3001 27.4998C22.2501 29.1498 24.7001 28.9998 25.4001 27.2498L31.2001 13.1498C31.7001 11.8498 31.1501 10.3498 29.9501 9.69977Z",
    fill: "#4D99F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aadcc74c37b151d5b0eb55d0253b1bac.svg";
export { ForwardRef as ReactComponent };